import NiceModal from '@ebay/nice-modal-react';

import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import Button from 'components/field/Button';
import PageHeader from 'components/global/PageHeader';
import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import useLocalStorage from 'hooks/useLocalStorage';
import useRouterFilters from 'hooks/useRouterFilters';

import { USERS } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

import { faLink } from '@fortawesome/pro-solid-svg-icons';

import CreatePermissionLinkForm from './CreatePermissionLinkForm';

const UsersSupportList = () => {
	const defaultSort = useMemo(() => [{ id: 'expiryDate', desc: true }], []);
	const [lastSwitchUsers, setLastSwitchUsers] = useLocalStorage('lastSwitchUsers', []);
	const usersSupportList = useSelector((state) => state.usersSupportList);

	const columns = useMemo(
		() => [
			{ Header: 'clientUserId', accessor: 'clientUserId', filterType: FilterType.number, width: 70, show: false },
			{
				Header: 'clientName',
				accessor: 'clientName',
				filterType: FilterType.string,
				width: 100,
				showOnMobile: true
			},
			{
				Header: 'fullName',
				accessor: 'fullName',
				filterType: FilterType.string,
				width: 100,
				showOnMobile: true
			},
			{
				Header: 'email',
				accessor: 'email',
				filterType: FilterType.string,
				width: 100
			},
			{
				Header: 'phone',
				accessor: 'phone',
				filterType: FilterType.number,
				width: 100,
				renderCell: ListComponents.PHONE
			},
			{
				Header: 'userType',
				accessor: 'userType',
				filterType: FilterType.multiSelection,
				width: 100
			},
			{
				Header: 'validityTime',
				accessor: 'expiryDate',
				filterType: FilterType.date,
				width: 100,
				renderCell: ListComponents.DATETIME
			},
			{
				Header: 'comment',
				accessor: 'supportComment',
				filterType: FilterType.string
			},
			{
				Header: 'expiredStatus',
				accessor: 'expiredStatus',
				filterType: FilterType.multiSelection,
				renderCell: ListComponents.STATUS
			},
			{
				Header: 'status',
				accessor: 'status',
				filterType: FilterType.multiSelection,
				renderCell: ListComponents.STATUS
			}
		],
		[]
	);

	useEffect(() => {
		const updatedLastSwitchUsers = [...lastSwitchUsers];
		let changed = false;
		updatedLastSwitchUsers &&
			updatedLastSwitchUsers.forEach((user) => {
				usersSupportList?.data?.forEach((clientUser) => {
					if (clientUser.clientUserId === user.clientUserId && clientUser.status !== user.status) {
						user.status = clientUser.status;
						changed = true;
					}
				});
			});
		if (changed) setLastSwitchUsers(updatedLastSwitchUsers);
	}, [usersSupportList, lastSwitchUsers]);

	const filtersFromRouter = useRouterFilters(columns);

	return (
		<div>
			<PageHeader title="clientUsers">
				<Button
					icon={faLink}
					lordIcon="https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/addOrder-icon.json.gz"
					label="permissionLink"
					onClick={() => NiceModal.show(CreatePermissionLinkForm)}
					variant="blue"
					className="addButton"
				/>
			</PageHeader>
			<DynamicList
				id={DYNAMICLISTS.CLIENT_USERS}
				columns={columns}
				fetchUrl={USERS.GET_SUPPORT_ACCESS_LIST}
				defaultFilters={filtersFromRouter}
				actionObjectType={ACTION_OBJECT_TYPES.SUPPORT}
				defaultSort={defaultSort}
				exportName="clientUsers"
			/>
		</div>
	);
};

export default UsersSupportList;
